<div [formGroup]="form">
  <!-- Outer card-->
  <div class="card mt-3">
    <!-- Outer card header-->
    <div class="card-header">
      <a id="TargetReferenz"></a>
      <h3>
        <i class="icon-einladende-person"></i><span i18n>Referenz</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <!-- Outer card body-->
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <!-- Inner card-->
          <div class="card">
            <!-- Inner card header-->
            <div class="card-header card-header-detail">
              <div *ngFor="let listItem of referenzListItems  | valueListFilter:{key: form.value['art']}">{{ listItem.value }}</div>
            </div>
            <!-- Inner card body-->
            <div class="card-body">
              <div class="row">
                <div class="col-md-8">
                  <div class="mb-3">
                    <label for="referenz.referenzArt" i18n [class.mandatory]="isMandatory('art')">Art der Referenz:</label>
                    <select class="form-select form-select-sm" id="referenz.referenzArt"
                            formControlName="art"
                            [class.is-invalid]="errorClassRequired(form.controls['art'])"
                            [ngbPopover]="popover_referenz_referenzArt"
                            appSaveLastFocussed>
                      <option *ngFor="let listItem of referenzListItems"
                              [ngValue]="listItem.key">
                        {{ listItem.value }}
                      </option>
                    </select>
                    <ng-template #popover_referenz_referenzArt>
                      <app-assistant *ngIf="appConfig.umgebung === 'MEK' || appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Art der Referenz für den beabsichtigten Aufenthalt des/der Antragstellenden ein. Wählen Sie hier bei Beantragung eines Studien-/Erwerbstätigkeitsvisums bitte immer "Bildungseinrichtung/Firma/Organisation".</span>
                      </app-assistant>
                      <app-assistant *ngIf="appConfig.umgebung === 'VIDEX' && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'"
                                     (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier die Art der Referenz für den beabsichtigten Aufenthalt des/der Antragstellenden ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
              <!-- Display selected list item-->
              <div [ngSwitch]="form.value['art']">
                <app-referenzperson formControlName="einladendePerson_referenzPerson" *ngSwitchCase="'2'"></app-referenzperson>
                <app-organisation formControlName="einladendeOrganisation_Bildungseinrichtung" *ngSwitchCase="'3'"></app-organisation>
                <app-hotel formControlName="hotel" *ngSwitchCase="'4'"></app-hotel>
                <app-akkreditierter-diplomat formControlName="akkreditierterDiplomat" *ngSwitchCase="'5'"></app-akkreditierter-diplomat>
                <app-eu-buerger formControlName="euBuerger" *ngSwitchCase="'6'"></app-eu-buerger>
                <app-wohnungsinhaber formControlName="wohnungsInhaber" *ngSwitchCase="'7'"></app-wohnungsinhaber>
                <app-anmietung-gewerblich formControlName="anmietungGewerblich" *ngSwitchCase="'8'"></app-anmietung-gewerblich>
                <app-anmietung-privat formControlName="anmietungPrivat" *ngSwitchCase="'9'"></app-anmietung-privat>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
